<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.employeegroup') }} > {{ $t('sidebar.create') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <PayrollEmployeeGroupForm
        :isSubmitted="isSubmitted"
        :employees="employees"
        :disabled="disabled"
        :form.sync="form"
        :showActionButtons="hasRoleEdit"
        @onSubmit="handleSubmit"
      />

      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  mixins: [discardFormMixin, userPermissionMixin],
  data () {
    return {
      loading: true,
      isSubmitted: false,
      disabled: false,
      form: null,
    }
  },

  computed: {
    ...mapState('hrm', {
      employees: 'employeeList',
    }),
  },

  created () {
    this.fetchData()
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.payroll.title'),
      current: {
        app_name: 'payroll',
        app_id: 14,
        module_id: 2,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 1,
      submenuAtIdx: 1,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('hrm', {
      getEmployeeList: 'getEmployeeList',
    }),
    ...mapActions('payroll', {
      createEmployeeGroup: 'createEmployeeGroup',
      updateEmployeeGroupAssign: 'updateEmployeeGroupAssign',
    }),
    async fetchData () {
      this.loading = true
      const params = { page: 1, limit: 100000 }
      await Promise.all([
        this.getEmployeeList(params),
      ])
      this.loading = false
      this.showFinish(this.$Progress)
    },
    async handleSubmit ({ name, assignIds = [] }) {
      this.disabled = true
      this.isSubmitted = true
      const responseCreate = await this.createEmployeeGroup({ name })
      const responseUpdateAssign = await this.updateEmployeeGroupAssign({ id: responseCreate.data._id, data: { emp_ids: assignIds } })
      if (responseCreate.success && responseUpdateAssign.success) {
        this.disabled = false
        this.isSubmitted = false
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: name }),
          color: 'success',
          icon: 'cloud',
        })
        this.$router.push({
          name: 'EmployeeGroupList',
          query: {
            ignoreDiscardAlert: true,
          },
        })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/payroll/group/Create.vue